import { Log } from '@probe.gl/log';
export default new Log({
  id: 'deck'
});
//# sourceMappingURL=log.js.map